export const LogoutUser = () => {
  localStorage.clear();
  window.location.replace("/");
}